import {
  IO_REQUEST,
  IO_RESPONSE,
  IO_ERROR,
  RequestAction,
  ResponseAction,
  ErrorAction
} from "./actions";
import { AjaxState, Request } from "./state";
import initial from "./state.initial";
import { ReducerActions, createReducerActions } from "../../Store/reducer";

type TActions = RequestAction | ResponseAction | ErrorAction;

const actions: ReducerActions<AjaxState, TActions> = {
  [IO_REQUEST]: ioRequest,
  [IO_RESPONSE]: ioResponse,
  [IO_ERROR]: ioError
};

function ioRequest(state: AjaxState) {
  let pending = Object.assign([], state.pending);
  pending.push({ start: new Date().getTime(), finish: 0 });
  return {
    ...state,
    pending,
    loading: true
  };
}

function ioResponse(state: AjaxState) {
  let pending: Request[] = Object.assign([], state.pending);
  let total: Request[] = Object.assign([], state.total);
  let request: Request | undefined = pending.shift();
  let ping: number = -1;
  if (request) {
    request.finish = new Date().getTime();
    ping = request.finish - request.start;
    total.push(request);
  }
  let ret: AjaxState = {
    ...state,
    ping,
    pending,
    total,
    loading: false
  };
  return ret;
}

function ioError(state: AjaxState) {
  let pending: Request[] = Object.assign([], state.pending);
  let total: Request[] = Object.assign([], state.total);
  let request: Request | undefined = pending.shift();
  let ping: number = -1;
  if (request) {
    request.finish = new Date().getTime();
    ping = request.finish - request.start;
    total.push(request);
  }
  return { ...state, ping, pending, total, loading: false };
}

export default createReducerActions(actions, initial);
